import { render, staticRenderFns } from "./SortableHeader.vue?vue&type=template&id=16e66fb4"
import script from "./SortableHeader.vue?vue&type=script&lang=js"
export * from "./SortableHeader.vue?vue&type=script&lang=js"
import style0 from "./SortableHeader.vue?vue&type=style&index=0&id=16e66fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports